module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_63.ab00252c.mp3";